<div
	class="obg-m-dropdown-menu-trigger"
	[class.dropdown-menu-trigger-active]="isActive"
	[matMenuTriggerFor]="menu"
	(menuOpened)="opened.emit(true)"
	(menuClosed)="opened.emit(false)"
>
	<ng-content select="[trigger]"></ng-content>
</div>

<mat-menu
	#menu="matMenu"
	xPosition="before"
	[overlapTrigger]="false"
	[backdropClass]="backdropClass"
	[class]="matMenuPanelClass"
>
	<ng-content (click)="handleClick($event)" [style.width]="width" select="[menu]"></ng-content>
</mat-menu>
